function attachClickAndSimulate() {
  const revokeConsentLink = document.getElementById(
    "revoke-consent"
  ) as HTMLLinkElement;

  const revokeCookieElement = document.querySelector(
    ".cn-revoke-cookie"
  ) as HTMLLinkElement;

  if (revokeConsentLink && revokeCookieElement) {
    revokeConsentLink.addEventListener("click", (event) => {
      event.preventDefault();

      revokeCookieElement.click();
    });
  }
}

function runScriptOnUpdateCheckout() {
  attachClickAndSimulate();
}

setInterval(runScriptOnUpdateCheckout, 1000);
